module.exports = __webpack_public_path__ + "img/dark-street-silhouette-thumb.b5b446cb.jpg";